import { Classifier } from './classifier.model';

export class SetClassifiers {
  static readonly type = '[ClassifierState] SetClassifiers';
  constructor(public readonly classifiers: Classifier[]) {}
}
